<template>
	<div>
      <v-container grid-list-xl userDetailsContainer>
        <v-layout row wrap>
          <v-tabs slider-color="grey">            
            <v-tab class="tab" :key="1" ripple>General Information</v-tab>            
            <v-tab class="tab" :key="2" ripple>Regions</v-tab>
            <v-tab class="tab" :key="3" ripple>Linked Users</v-tab>
            <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="1">
              <v-container grid-list-xl style="padding-left: 15px !important; padding-top: 2% !important;">
                <v-layout row wrap> 
                  <h3>General Info</h3>
                  <v-data-table loading="true" :headers="contactHeaders" :items="currentUser" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">                                                        
                        <td width="15%">{{ props.item.contactno }}</td>
                        <td width="15%">{{ fncCheckNull(props.item.alt_contactno) }}</td>
                        <td width="15%">{{ props.item.email }}</td>
                        <td width="15%">{{ props.item.vat_no }}</td>
                        <td width="25%">{{ props.item.address }}</td>
                        <td width="15%">{{ props.item.pmoc }}</td>
                    </template> 
                  </v-data-table>
                  <h3 class="headerSplit">Limits</h3>
                  <v-data-table loading="true" :headers="limitHeaders" :items="currentUser" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td width="25%">{{ props.item.discount_max }}%</td>
                      <td width="25%">{{ props.item.discount_def }}%</td>
                      <td width="25%">{{ props.item.contri_min }}%</td>
                      <td width="25%">{{ props.item.inc_max }}</td>
                    </template>
                  </v-data-table>
                  <h3 class="headerSplit">Additional Info</h3>
                  <v-data-table loading="true" :headers="infoHeaders" :items="currentUser" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td width="20%">{{ props.item.active }}</td>
                      <td width="20%">{{ fncGetUserType(props.item.type) }}</td>
                      <td width="20%">{{ props.item.created }}</td>
                      <td width="20%">{{ props.item.modified }}</td>
                      <td width="20%">{{ fncTrim( props.item.pricelists ) }}</td>
                    </template>
                  </v-data-table> 
                </v-layout>
              </v-container>
            </v-tab-item>                      
            <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="2">
              <v-container grid-list-xl style="padding-top: 2% !important;">
                <v-layout row wrap>
                  <v-flex xs3>
                    <v-text-field append-icon="search" label="Search" solo single-line v-model="search"></v-text-field><br />
                  </v-flex>
                  <v-data-table loading="true" :search="search" :headers="regionHeaders" :items="currentRegions" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>                      
                    </template>
                  </v-data-table>                   
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item class="pl-4 pr-4 pt-4 pb-4" :key="3">
              <v-container grid-list-xl style="padding-top: 2% !important;">
                <v-layout row wrap>  
                  <v-flex lg12>                    
                    <label class="blackLabel">User Type:</label>
                    <v-select :items="linkType" v-model="linkTypeSingle" label="User Type" autocomplete solo></v-select>
                  </v-flex>	
                  <v-flex xs3>
                    <v-text-field append-icon="search" label="Search" v-if="linkTypeSingle.id == 'rep'" solo single-line v-model="searchReps"></v-text-field><br />
                  </v-flex>                  
                  <v-data-table loading="true" :search="searchReps" v-if="linkTypeSingle.id == 'rep'" :headers="regionHeaders" :items="userReps" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                    </template>
                  </v-data-table>
                  <v-flex xs3>
                    <v-text-field append-icon="search" label="Search" v-if="linkTypeSingle.id == 'company'" solo single-line v-model="searchCompanies"></v-text-field><br />
                  </v-flex>
                  <v-data-table loading="true" :search="searchCompanies" v-if="linkTypeSingle.id == 'company'" :headers="regionHeaders" :items="userCompanies" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                    </template>
                  </v-data-table>
                  <v-flex xs3>
                    <v-text-field append-icon="search" label="Search" v-if="linkTypeSingle.id == 'customer'" solo single-line v-model="searchCustomers"></v-text-field><br />
                  </v-flex>                  
                  <v-data-table loading="true" :search="searchCustomers" v-if="linkTypeSingle.id == 'customer'" :headers="regionHeaders" :items="userCustomers" hide-actions disable-initial-sort class="elevation-1">
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.name }}</td>
                    </template>
                  </v-data-table>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs>
          <div class="pl-4 pr-1 pb-2 pt-2 buttonHolder">
            <div style="float: right">
              <v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>              
            </div>
          </div>
          <v-flex lg12 class="requiredMessage">
            <small><strong>&nbsp;</strong></small>
          </v-flex>
        </v-layout>           
      </v-container>	
      </div>
</template>

<script>

	import { mapGetters } from 'vuex';
    
	export default {
        name: 'UserNotifications',
        components: {},
		data () {
          return {	     
              linkTypeSingle: '',
              linkType: [
                { id: 'rep', text: 'Manufacturer Users' },
                { id: 'customer', text: 'Customer Users' },
                { id: 'company', text: 'Company Users' },
              ],
              search: '',
              searchReps: '',
              searchCustomers: '',
              searchCompanies: '',
              currentUserCompany: this.$store.getters.currentUserCompany,
              contactHeaders: [                
                { text: 'Contact No', value: 'contact_no', width: '15%' },
                { text: 'Alternative Contact No', value: 'alt_contactno', width: '15%' },
                { text: 'Email Addess', value: 'email', width: '15%' },
                { text: 'Vat No', value: 'vat_no', width: '15%' },
                { text: 'Physical Address', value: 'address', width: '25%' },
                { text: 'Preferred Contact Method', value: 'pmoc', width: '15%' }                 
              ],
              limitHeaders: [
                { text: 'Maximum Discount', value: 'discount_max', width: '25%' },
                { text: 'Default Discount', value: 'discount_def', width: '25%' },
                { text: 'Contribution Minimum', value: 'contri_min', width: '25%' },
                { text: 'Maximum Incidental Value', value: 'inc_max', width: '25%' }               
              ],
              infoHeaders: [
                { text: 'Active', value: 'active', width: '20%' },
                { text: 'User Type', value: 'type', width: '20%' },
                { text: 'Created On', value: 'created', width: '20%' },
                { text: 'Last Modified On', value: 'modified', width: '20%' },
                { text: 'Pricelists', value: 'pricelists', width: '20%' }
              ],
              regionHeaders: [
                { text: 'Name', value: 'name' }                
              ]		
			}
		},
        methods: {
            fncCheckNull(strCheck) {
              if ( strCheck == null ) {
                return 'N/A';
              } else {
                return strCheck;
              }
            },
            fncHideModal () {
                this.$store.commit('hideModal');
            },
            fncCreateAddress() {
              var strAddress = '';
              if (this.currentCompany.address_1 != '' ) {
                strAddress += this.currentCompany.address_1 + '<br />';
              }
              if (this.currentCompany.address_2 != '') {
                strAddress += this.currentCompany.address_2 + '<br />';
              }
              if (this.currentCompany.postal_code != '') {
                strAddress += this.currentCompany.postal_code + '<br />';
              }
              if ( strAddress == '' ) {
                strAddress = 'N/A';
              }
              return strAddress;
            },
            fncGetUserType(type) {
              var userType = 'N/A';
              if ( type == 1 ) {
                userType = this.objAuthorize.manu_user_alias;                
              } else if ( type == 2 ) {
                userType = this.objAuthorize.customer_user_alias;
              } else if ( type == 3 ) {
                userType = this.objAuthorize.specifier_user_alias;
              } else if ( type == 4 ) {
                userType = this.objAuthorize.public_user_alias;
              }
              return userType;
            },
            fncTrim( toTrim ) {
              return toTrim.substring(0, toTrim.length - 2);
            }
		},
		computed: {
			...mapGetters([
                'objAuthorize',
                'globalModalParams',
                'currentUser',
                'currentRegions',
                'userCustomers',
                'userCompanies',
                'userReps'

			])
        }
	}
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css';
</style>